import React from 'react';
import { Router, Route, Switch, withRouter } from 'react-router';
import withRole from 'components/Security/withRole';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';
import {
  ROLE_SHOW_BRAND_ACCESS_KEY,
  ROLE_EDIT_BRAND_ACCESS_KEY,
} from 'helpers/roles';

import AccessKeysModule from './modules/AccessKeysModule';
import AccessKeyEditModule from './modules/AccessKeyEditModule';

const AccessKeys = props => {
  const { history, match } = props;
  const ProtectedAccessKeysList = withRole(
    ROLE_SHOW_BRAND_ACCESS_KEY,
    AccessKeysModule
  );
  const ProtectedEditForm = withRole(
    ROLE_EDIT_BRAND_ACCESS_KEY,
    AccessKeyEditModule
  );

  return (
    <DataGridStateContextProvider>
      <Router history={history}>
        <Switch>
          <Route
            exact={true}
            path={`${match.url}/`}
            render={parentProps => (
              <ProtectedAccessKeysList {...props} {...parentProps} />
            )}
          />
          <Route
            path={`${match.url}/edit/:id`}
            render={parentProps => (
              <ProtectedEditForm {...props} {...parentProps} />
            )}
          />
        </Switch>
      </Router>
    </DataGridStateContextProvider>
  );
};

export default withRouter(AccessKeys);
